module.exports = __webpack_public_path__ + "static/media/covidBlue.2d01e4ca.svg";